import React from 'react'; import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { Icon } from '../../common/components';
import { selectors } from '../../modules/customer/profile';
import { config } from '../../modules';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const getUrlToCustomerProfilePage = (customerId, pathname) => {
    return customerId && pathname !== '/' ? "#/customer/" + customerId : "#";
};

const getUrl = (customerID, type) => `#/customer/${customerID}/${type}`;

class Header extends React.Component {

    getAction = (customerID, type) => () => ({});

    render = () => {
        const { isLoggedIn, onLogin, onLogout, user, title, version, salesUrl, customerID, pathname, winbackUrl, customerDetails: { firstName, lastName } } = this.props;
        return (
            <header className="global-header">
                <a href="/" className="global-header-title">
                    <span className="global-header-logo">
                        <Icon name="logo-white" alt="RiksTV" />
                    </span>
                    <span className="global-header-name">
                        {title}
                    </span>
                    <span className="env">{this.props.env}</span>
                </a>
                <div className="global-header-menu">
                    <a href="/#/">Søk kunde</a>
                    <span className="separator"></span>
                    <a target="_blank" href={salesUrl}>Nysalg</a>
                    {customerID && isLoggedIn && <span>
                        <span className="separator"></span>
                        <span className="customer-name">{firstName} {lastName}: </span>
                        <a href={getUrl(customerID, '')}>Oversikt</a>
                        <a href={getUrl(customerID, 'invoices')}>Faktura</a>
                        <a href={getUrl(customerID, 'products')}>Produkter</a>
                        <a href={getUrl(customerID, 'shippingOrders')}>Fraktordre</a>
                        <a href={getUrl(customerID, 'workOrders')}>Arbeidsordre</a>
                    </span>
                    }
                </div>
                {isLoggedIn &&
                    <div className="global-header-user">
                        <span>{user.name}</span>
                        <img src={user.picture} />
                        <a href="#" onClick={onLogout}>Logg ut</a>
                    </div>
                }
                {!isLoggedIn &&
                    <div className="global-header-user">
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            onLogin()
                        }}>Logg inn</a>
                    </div>
                }
            </header>
        )
    };
}

Header.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    onLogin: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
    user: PropTypes.object,
    title: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    salesUrl: PropTypes.string.isRequired,
    winbackUrl: PropTypes.string.isRequired
};

const mapStateToProps = createStructuredSelector({
    customerID: selectors.getCustomerID,
    customerDetails: selectors.getCustomerDetails,
    salesUrl: config.selectors.getSalesUrl,
    winbackUrl: config.selectors.getWinbackUrl,
    env: config.selectors.getEnv
});

export default connect(mapStateToProps)(Header);
